module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "research_group_container",
    staticStyle: {
      "background": "#fafafa"
    }
  }, [_c('div', {
    staticClass: "page-progress flex-col"
  }, [_c('div', {
    staticClass: "main1 flex-col"
  }, [_c('div', {
    staticClass: "group_progress flex-col",
    style: (!_vm.showaberrationType ? {
      height: '118px'
    } : {})
  }, [_c('div', {
    staticClass: "layer3 flex-col"
  }, [_c('div', {
    staticClass: "main3 flex-row justify-between"
  }, [_c('span', {
    staticClass: "info1"
  }, [_vm._v("订单编号：" + _vm._s(_vm.SCProgressInfo.orderNo))]), _vm._v(" "), _c('button', {
    staticClass: "block1 flex-col",
    attrs: {
      "id": "tag-copy",
      "data-clipboard-text": _vm.SCProgressInfo.orderNo
    },
    on: {
      "click": _vm.handleCopy
    }
  }, [_c('span', {
    staticClass: "info2"
  }, [_vm._v("复制")])])]), _vm._v(" "), _c('div', {
    staticClass: "main4 flex-col"
  }), _vm._v(" "), _c('div', {
    staticClass: "main5 flex-row"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "info3"
  }, [_vm._v(_vm._s(_vm.SCProgressInfo.solutionName))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showaberrationType),
      expression: "showaberrationType"
    }],
    staticClass: "main6 flex-row justify-between"
  }, [_c('img', {
    staticClass: "label2",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": "/static/img/注意.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "word2"
  }, [_vm._v(_vm._s(_vm.getaberration(_vm.SCProgressInfo.aberrationType)))])])])]), _vm._v(" "), _vm._l((_vm.SCProgressInfo.contractProgressInfoList), function(contractProgressInfo, index) {
    return _c('div', {
      key: index,
      staticClass: "group3 flex-col"
    }, [_c('contract-progress-info', {
      attrs: {
        "contractProgressInfo": contractProgressInfo,
        "aberrationType": _vm.SCProgressInfo.aberrationType
      }
    })], 1)
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer1 flex-col"
  }, [_c('img', {
    staticClass: "icon3",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": "/static/img/service_product.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e46a633","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/serviceProgressRefactor/serviceProgress/index.vue
// module id = 1585
// module chunks = 8